import { APP_INITIALIZER, EnvironmentProviders, Provider } from '@angular/core';
import { Amplify, ResourcesConfig } from 'aws-amplify';
import { Hub } from 'aws-amplify/utils';
import { Store } from '@ngrx/store';
import { accountActions, accountAPIActions } from '../../store/account/account.state';
import { AccountService } from 'app/core/auth/account.service';
import { TravomateAccountService } from './travomate.account.service';
import { UserRouteAccessService } from 'app/core/auth/user-route-access.service';
import { TravomateUserRouteAccessService } from './travomate.user-route-access.service';
import { TravomateStateStorageService } from './travomate.state-storage.service';
import { StateStorageService } from 'app/core/auth/state-storage.service';

export const amplifyConfig: ResourcesConfig = {
  Auth: {
    Cognito: {
      userPoolId: USER_POOL_ID,
      userPoolClientId: USER_POOL_CLIENT_ID,
    },
  },
};

export const amplifyFormFields = {
  signUp: {
    username: {
      order: 1,
    },
    email: {
      order: 2,
    },
    given_name: {
      label: 'First Name',
      order: 3,
    },
    family_name: {
      label: 'Last Name',
      order: 4,
    },
    password: {
      order: 5,
    },
    confirm_password: {
      order: 6,
    },
  },
};

export const authProviders: Provider[] | EnvironmentProviders[] = [
  { provide: APP_INITIALIZER, multi: true, useFactory: () => () => Amplify.configure(amplifyConfig) },
  {
    provide: APP_INITIALIZER,
    multi: true,
    deps: [Store, TravomateAccountService],
    useFactory: (store: Store, accountService: TravomateAccountService) => () => {
      Hub.listen('auth', data => {
        if (data.payload.event === 'signedOut') {
          store.dispatch(accountActions.logout());
        }
        if (data.payload.event === 'signedIn') {
          store.dispatch(accountAPIActions.currentUser());
          accountService.restoreUrl();
        }
      });
    },
  },
  { provide: AccountService, useClass: TravomateAccountService },
  { provide: UserRouteAccessService, useValue: TravomateUserRouteAccessService },
  { provide: StateStorageService, useClass: TravomateStateStorageService },
];
